import { Link } from 'foundations-components/transitional/components/Link';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { stripPathPagination } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PageOneLink() {
  return /*#__PURE__*/_jsx(Link, {
    href: stripPathPagination(window.location.href),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "appMarketplace.storefront.results.resultsPage.noResultsEmptyState.backToPageOne"
    })
  });
}